/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminMarketReferenceSource = {
    ReferenceSourceEbayAPI: 'ebay_api',
    ReferenceSourceManual: 'manual',
    ReferenceSourceDerived: 'derived_from_ebay'
} as const;
export type AdminMarketReferenceSource = typeof AdminMarketReferenceSource[keyof typeof AdminMarketReferenceSource];


export function instanceOfAdminMarketReferenceSource(value: any): boolean {
    for (const key in AdminMarketReferenceSource) {
        if (Object.prototype.hasOwnProperty.call(AdminMarketReferenceSource, key)) {
            if (AdminMarketReferenceSource[key as keyof typeof AdminMarketReferenceSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminMarketReferenceSourceFromJSON(json: any): AdminMarketReferenceSource {
    return AdminMarketReferenceSourceFromJSONTyped(json, false);
}

export function AdminMarketReferenceSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketReferenceSource {
    return json as AdminMarketReferenceSource;
}

export function AdminMarketReferenceSourceToJSON(value?: AdminMarketReferenceSource | null): any {
    return value as any;
}

export function AdminMarketReferenceSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminMarketReferenceSource {
    return value as AdminMarketReferenceSource;
}

